import 'jquery-timepicker/jquery.timepicker.js';
import datepickerFactory from 'jquery-datepicker';

export default {
    init() {
        window.registration_end_customized = false;
    },
    finalize() {
        // Bible Study selection

        const radio_selector = 'select[name="bible_study_format"]';

        let show_study_dropdown = function() {
            let radio = jQuery(radio_selector).find('option:selected');

            let translation = jQuery('#bible_translation');
            translation.hide();

            jQuery('select[name="bible_study_title"]')
                .attr('name', '')
                .hide();
            jQuery('select.hidden')
                .parent()
                .hide();

            let dropdown = jQuery('#' + radio.data('studies'))
                .attr('name', 'bible_study_title')
                .parent()
                .show();
            if (dropdown.find('li.selected').length == 0) {
                dropdown
                    .find('li')
                    .first()
                    .addClass('selected');
                dropdown.find('select').val(dropdown.find('select option:first').val());
            }

            if (radio.data('bible-translation') == 'collect') {
                translation.show();
            }

            let secondary = radio.data('secondary');
            jQuery('.secondary_study').addClass('hidden');
            if (secondary != '') {
                jQuery('#' + secondary).removeClass('hidden');
            }
        };

        jQuery(radio_selector).change(show_study_dropdown);
        show_study_dropdown();

        // Geocoding addresses

        let geocode_address = function() {
            // Setup variables

            let address = '';
            let callback = function(results, status) {
                if (status == 'OK') {
                    let result = results[0];
                    let lat = result.geometry.location.lat();
                    let lng = result.geometry.location.lng();
                    console.log(lat);
                    console.log(lng);
                    jQuery('input[name="latitude"]').val(lat);
                    jQuery('input[name="longitude"]').val(lng);
                } else {
                    console.warn('Geocode was not successful for the following reason: ' + status);
                }
            };

            // Check if all addresses are filled
            let street = jQuery('#street_address').val();
            let city = jQuery('#city').val();
            let state = jQuery('#state').val();
            let zip = jQuery('#zip').val();

            if (street == '' || city == '' || state == '' || zip == '') {
                // Wait until address input is completed to geocode
            } else {
                // Compile into one string

                address = street + ', ' + city + ', ' + state + ' ' + zip;

                // Call Google Maps

                window.googleMapsGeocode(address, callback);
            }
        };

        jQuery('.geocoded_address').on('change', geocode_address);
        geocode_address();

        // Update end minimums
        // Commented most of this section out because it interfered with date picker - ST

        // const start_selector = '#group_starts';

        // let update_end_minimum = function(ev = null) {

        //     let start;

        //     if(ev === null) {
        //         start = jQuery(start_selector);
        //     } else {
        //         start = jQuery(this);
        //     }

        //     jQuery('#group_ends').attr('min', start.val());

        // };

        // jQuery(start_selector).on('change', update_end_minimum);
        // update_end_minimum();

        // Set default values for registration end
        // Requires start_selector constant

        // const registration_start_selector = '#registration_starts';
        // const registration_end_selector = '#registration_ends';

        // let registration_end_default_value = function() {

        //     if(! window.registration_end_customized) {
        //         jQuery(registration_end_selector).val(jQuery(start_selector).val());
        //     }

        // };

        // let registration_end_custom_value = function() {
        //     window.registration_end_customized = true;
        // };

        // jQuery(start_selector).on('change', registration_end_default_value);

        // jQuery(registration_end_selector).on('change', registration_end_custom_value);

        // Form initial values

        const max_num_of_seats_selector = '#max_num_of_seats';

        let form_initial_values = function() {
            // let end = jQuery(registration_end_selector);
            // if(end.val() != '') {
            //     window.registration_end_customized = true;
            // } else {
            //     registration_end_default_value();
            // }

            // let start = jQuery(registration_start_selector);
            // if(start.val() == '') {
            //     start.val(start.attr('min'));
            // }

            let max_seats = jQuery(max_num_of_seats_selector);
            if (max_seats.val() == '') {
                max_seats.val(15);
            }
        };

        form_initial_values();

        // Show additional fee inputs

        const additional_toggle_selector = '#fee_required';

        let additional_toggle = function() {
            let checked = jQuery(additional_toggle_selector).prop('checked');
            if (checked == true) {
                jQuery('#fee').show();
            } else {
                jQuery('#fee').hide();
                jQuery('#fee_amount').val('');
            }
        };

        jQuery(additional_toggle_selector).on('change', additional_toggle);
        additional_toggle();

        // Show public / private notice on Meeting Settings view

        const open_to_public_selector = 'input[name="open_to_public"]';

        let show_open_to_public_notice = function() {
            jQuery('.open_to_public_notice').hide();

            let val = jQuery(open_to_public_selector + ':checked').val();

            if (val == 'public') {
                jQuery('#public_notice').show();
            } else if (val == 'private') {
                jQuery('#private_notice').show();
            }
        };

        jQuery(open_to_public_selector).on('change', show_open_to_public_notice);
        show_open_to_public_notice();

        // Show address field only when location type is in-person

        const location_type_selector = 'input[name="location_type"]';

        let show_physical_location_fields = function() {
            let physical_location_fields = jQuery('#location');

            let val = jQuery(location_type_selector + ':checked').val();

            if (val !== undefined && val.toLowerCase() == 'physical') {
                physical_location_fields.show();
                jQuery('.is-physical_required').prop('required', true);
            } else {
                physical_location_fields.hide();
                jQuery('.is-physical_required').prop('required', false);
            }
        };

        jQuery(location_type_selector).on('change', show_physical_location_fields);
        show_physical_location_fields();

        // Secondary audience toggle

        jQuery('#secondary_toggle').on('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            jQuery('#secondary_audience_container').show();
            jQuery(this).hide();
        });

        // Start and end time

        jQuery('#time_starts, #time_ends').timepicker();

        /// Time zone display and change

        var timezone = $('#timezone option:selected').text();
        $('#selected_timezone').text(timezone);
        $('select#timezone').change(function() {
            $('#selected_timezone').text($(this).val());
            $('#timezone_selection').slideUp();
        });
        $('#change_selected_timezone').click(function() {
            $('#timezone_selection').slideToggle();
            return false;
        });

        /// Group capacity up and down

        $('#capacity_plus').click(function(ev) {
            ev.preventDefault();
            var seats = $('#max_num_of_seats').val();
            var seats = parseInt(seats) + 1;
            $('#max_num_of_seats').val(seats);
        });

        $('#capacity_minus').click(function(ev) {
            ev.preventDefault();
            var seats = $('#max_num_of_seats').val();
            var seats = parseInt(seats) - 1;
            $('#max_num_of_seats').val(seats);
        });

        /// Hide and show address options

        $('#use_alt_address').click(function(ev) {
            ev.preventDefault();
            $('#meeting_address_alt, #meeting_address_def').slideToggle();
        });

        // / Category name(s) on second page of form

        $('input[name="add_pup"]').on('click', function() {
            if ($(this).is(':checked')) {
                var secondary = 'and Precept Upon Precept®';
                $('#secondary_category_title').text(secondary);
            } else {
                var secondary = '';
                $('#secondary_category_title').text(secondary);
            }
        });

        $('input[name="add_inandout"]').on('click', function() {
            if ($(this).is(':checked')) {
                var secondary = 'and In and Out®';
                $('#secondary_category_title').text(secondary);
            } else {
                var secondary = '';
                $('#secondary_category_title').text(secondary);
            }
        });

        var selectedcat = $("select[name='bible_study_format'] option:selected").val();
        if (selectedcat == 'Precept Upon Precept') {
            $('#category_title').text('Precept Upon Precept®');
        } else if (selectedcat == 'In & Out') {
            $('#category_title').text('In & Out®');
        } else {
            $('#category_title').text(selectedcat);
        }
        $('select[name=bible_study_format]').on('change', function() {
            selectedcat = $(this).val();
            if (selectedcat == 'Precept Upon Precept') {
                $('#category_title').text('Precept Upon Precept®');
            } else if (selectedcat == 'In & Out') {
                $('#category_title').text('In & Out®');
            } else {
                $('#category_title').text($(this).val());
            }
        });

        /// Message about study materials
        $('#study-explanation').text('Study materials will be provided to group members at no cost to them.');
        $('select[name=who_buys_study]').on('change', function() {
            var selectedmaterials = $("select[name='who_buys_study'] option:selected").text();
            if (selectedmaterials == 'Provided at no cost') {
                var study_explanation = 'Study materials will be provided to group members at no cost to them.';
            } else if (selectedmaterials == 'Purchase in group') {
                var study_explanation =
                    'Study materials will be available for purchase directly from you or your organization (i.e. the first day of the group)';
            } else if (selectedmaterials == 'Purchase online') {
                var study_explanation =
                    'Group members are responsible to purchase study materials on their own before arriving at the group.';
            }
            $('#study-explanation').text(study_explanation);
        });

        /// Message about childcare
        $('#childcare-explanation').text('Childcare is not available for this group.');
        $('select[name=childcare_offered]').on('change', function() {
            var selectedmaterials = $("select[name='childcare_offered'] option:selected").text();
            if (selectedmaterials == 'Not Provided') {
                var study_explanation = 'Childcare is not available for this group.';
            } else if (selectedmaterials == 'Provided: Fee Required') {
                var study_explanation =
                    'Childcare is available to group members and requires a fee. Contact the group leader for details.';
            } else if (selectedmaterials == 'Provided: No Fee Required') {
                var study_explanation =
                    'Childcare is available at no cost to group members. Contact the group leader for details.';
            } else if (selectedmaterials == 'As Needed (Upon Request)') {
                var study_explanation =
                    'Childcare is available upon request. Contact the group leader in advance for details and to request childcare.';
            }
            $('#childcare-explanation').text(study_explanation);
        });

        // π ----
        // :: DATE FIELDS ---------------------------::
        // ____
        function verifyDate() {
            const groupStart = parseInt(document.getElementById('group_starts').value.replace(/-|\s/g, ''));
            const groupEnd = parseInt(document.getElementById('group_ends').value.replace(/-|\s/g, ''));
            const regStart = parseInt(document.getElementById('registration_starts').value.replace(/-|\s/g, ''));
            const regEnd = parseInt(document.getElementById('registration_ends').value.replace(/-|\s/g, ''));
            const dateError = document.getElementById('date-error');
            const regDateError = document.getElementById('reg-date-error');

            if (groupStart <= groupEnd) {
                dateError.classList.add('hidden');
            } else {
                dateError.classList.remove('hidden');
            }

            if (regStart <= regEnd) {
                regDateError.classList.add('hidden');
            } else {
                regDateError.classList.remove('hidden');
            }

            if (groupStart <= groupEnd && regStart <= regEnd) {
                $('[data-form-submit]').prop('disabled', false);
            } else {
                $('[data-form-submit]').prop('disabled', true);
            }
        }

        datepickerFactory($);
        $('#group_starts').datepicker({
            dateFormat: 'yy-mm-dd',
            minDate: '+5',
            maxDate: '+1y',
            onSelect: function() {
                $(this).valid();
                var minEndDate = $(this).val();
                $('#group_ends').datepicker('option', { minDate: minEndDate });
                verifyDate();
            }
        });
        $('#group_ends').datepicker({
            dateFormat: 'yy-mm-dd',
            minDate: '+5',
            maxDate: '+1y',
            onSelect: function() {
                $(this).valid();
                verifyDate();
            }
        });
        $('#registration_starts').datepicker({
            dateFormat: 'yy-mm-dd',
            minDate: '+5',
            maxDate: '+1y',
            onSelect: function() {
                $(this).valid();
                const minEndDate = $(this).val();
                $('#registration_ends').datepicker('option', { minDate: minEndDate });
                verifyDate();
            }
        });
        $('#registration_ends').datepicker({
            dateFormat: 'yy-mm-dd',
            minDate: '+5',
            maxDate: '+1y',
            onSelect: function() {
                $(this).valid();
                verifyDate();
            }
        });

        $('#alt-phone').on('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            $(this)
                .parent()
                .remove();
            $('input[name="contact_phone"]')
                .attr('type', 'text')
                .usPhoneFormat();
        });

        $('#alt-email').on('click', function(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            $(this)
                .parent()
                .remove();
            $('input[name="contact_email"]').attr('type', 'email');
        });

        /* :: Manual Edits
        {+} ---------------------------------- */
        const dateFields = document.querySelectorAll('[data-date-field]');

        dateFields.forEach(function(field) {
            field.onchange = () => {
                verifyDate();
            };
        });
    }
};

/// Message on edit load
$(document).ready(function() {
    $('#modal-edit-alert').modal();
});

/// Message on group creation
$(document).ready(function() {
    $('#modal-group-created').modal();
});
